import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LocalAttraction } from '../models/local-attraction.model';
// import { LatLon } from '../../util/geodesy/latlon';


@Injectable()
export class LocalAttractionService {
  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * updates specified entity via api
   * @param {number} airportID
   * @param {LocalAttraction} localAttraction
   * @return {Promise<any>}
   */
  putLocalAttraction(airportID: number, localAttraction: LocalAttraction): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/afmTravels/${localAttraction.id}`;
    try {
      const BODY = this._getLocalAttractionJSON(localAttraction);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * adds specified entity via api
   * @param {number} airportID
   * @param {LocalAttraction} localAttraction
   * @return {Promise<any>}
   */
  postLocalAttraction(airportID: number, localAttraction: LocalAttraction): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/afmTravels/`;
    try {
      const BODY = this._getLocalAttractionJSON(localAttraction);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * deletes specified entity via api
   * @param {number} airportID
   * @param {number} localAttractionID
   * @return {Promise<any>}
   */
  deleteLocalAttraction(airportID: number, localAttractionID: number): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/afmTravels/${localAttractionID}`;
    try {
      return this._http.delete(URL).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts entity to json obj
   * @param {LocalAttraction} localAttraction
   * @return {any}
   * @private
   */
  _getLocalAttractionJSON (localAttraction: LocalAttraction): any {
    const loc = {
      latitude: localAttraction.location.lat,
      longitude: localAttraction.location.lon
    };
    return {
      travelType: localAttraction.travelType,
      travelRef: localAttraction.travelRef,
      phone: localAttraction.phone,
      website: localAttraction.website,
      name: localAttraction.name,
      address: localAttraction.address,
      street1: localAttraction.street1,
      city: localAttraction.city,
      state: localAttraction.state,
      zip: localAttraction.zip,
      country: localAttraction.country,
      distance: localAttraction.distance,
      location: loc
    };
  }
}
